import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function FAQSection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Es esto legal?',
    answer: '100%. Toda la información se basa en publicaciones oficiales del IRS que tú mismo puedes verificar.'
  }, {
    question: '¿Necesito un contador para esto?',
    answer: 'No. La guía está escrita en español simple para que tú mismo entiendas las reglas y se las lleves a tu preparador o las apliques en TurboTax.'
  }, {
    question: '¿Qué pasa si ya mandé mis taxes este año?',
    answer: "El Hack #1 te enseña cómo hacer una 'Enmienda' para pedir el dinero que te faltó, incluso después de haber recibido tu primer cheque."
  }];
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5" data-id="element-5">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-6">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12" data-id="element-7">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-8">
          {faqs.map((faq, index) => <div key={index} className="bg-navy-dark border border-white/10 rounded-xl overflow-hidden transition-all duration-300" data-id="element-9">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-10">
                <span className="text-lg md:text-xl font-bold text-white pr-4" data-id="element-11">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-gold-primary flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-12" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-48 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-13">
                <p className="text-lg text-gray-300" data-id="element-14">{faq.answer}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}